<div class="topnav prevent-select">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu active">
      <div class="collapse navbar-collapse active" id="topnav-menu-content">
        <ul class="navbar-nav">
          @for (item of menuItems; track $index) {
          <ng-container
            *ngIf="(item.label !== 'MENUITEMS.USERMANAGEMENT.TEXT') || (storedAdminInfo && (storedAdminInfo.role_name === 'Admin' || storedAdminInfo.role_name === 'Owner'))">
            <li class="nav-item dropdown"
              [ngClass]="{'active': (item.link === '/filemanager' && (isFileManagerActive$ | async)) || (item.link === '/user/user-list' && (isUserManagementActive$ | async)) || (item.link === '/dashboard' && (isDashboardActive$ | async))}">
              @if(item.subItems.length){
              <a class="nav-link dropdown-toggle arrow-none" (click)="onMenuClick(item.parentId,item)"
                href="javascript: void(0);" id="topnav-components" role="button" draggable="false">
                <i class="bx {{item.icon}} me-1"></i>
                {{item.label| translate }}
                <div class="arrow-down"></div>
              </a>
              }@else{
              <a class="nav-link dropdown-toggle arrow-none" href="javascript: void(0);" id="topnav-components"
                [routerLink]="item.link === '/filemanager' ? (item.link + '/' + storedAdminInfo['hashed_node_id']) : item.link"
                role="button" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" draggable="false">
                <!-- @if(hasItems(item)){ -->
                <i class="bx {{item.icon}} me-2"></i>{{ item.label | translate }} <div class=""></div>
                <!-- } -->
              </a>
              }
              @if(hasItems(item)){
              <div class="dropdown-menu"
                [ngClass]="{'dropdown-mega-menu-xl px-2':  item.subItems.length > 11 , 'show':item.isCollapsed}"
                aria-labelledby="topnav-dashboard">
                <ng-template ngFor let-i="index" let-subitem [ngForOf]="item.subItems">
                  @if(item.subItems.length < 11 && !hasItems(subitem)){ <a class="col dropdown-item side-nav-link-ref"
                    [routerLink]="subitem.link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                    {{subitem.label | translate }}
                    </a>}
                    @else if(item.subItems.length == 11 && !hasItems(subitem)){
                    <div>
                      <a class="dropdown-item dropdown-toggle" href="javascript: void(0);" [routerLink]="subitem.link"
                        routerLinkActive="active" (click)="onMenuClick(subitem.parentId,subitem)" draggable="false">{{
                        subitem.label |
                        translate }}
                        <div class="arrow-down"></div>
                      </a>
                    </div>
                    }@else if (item.subItems.length > 11) {
                    <div>
                      @if(i % 3 == 0){
                      <div class="row">
                        <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                            [routerLink]="subitem.link" draggable="false">{{item.subItems[i].label | translate}}</a>
                        </div>
                        <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                            [routerLink]="item.subItems[i + 1]?.link" draggable="false">{{item.subItems[i + 1]?.label |
                            translate}}</a>
                        </div>
                        <div class="col-lg-4"><a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                            [routerLink]="item.subItems[i + 2]?.link" draggable="false">{{item.subItems[i + 2]?.label |
                            translate}}</a>
                        </div>
                      </div>
                      }
                    </div>
                    }

                    @if(hasItems(subitem)){
                    <div class="dropdown">
                      <a class="dropdown-item dropdown-toggle" href="javascript: void(0);"
                        (click)="onMenuClick(subitem.parentId,subitem)" draggable="false">{{ subitem.label | translate
                        }}
                        <div class="arrow-down"></div>
                      </a>
                      <div class="dropdown-menu" [ngClass]="{'show':subitem.isCollapsed}">
                        <ng-template ngFor let-i="index" let-subSubitem [ngForOf]="subitem.subItems">
                          @if(hasItems(subSubitem)){
                          <div class="dropdown">
                            <a class="dropdown-item dropdown-toggle" href="javascript: void(0);"
                              (click)="onMenuClick(subSubitem.parentId,subSubitem)" draggable="false">{{
                              subSubitem.label | translate }}
                              <div class="arrow-down"></div>
                            </a>
                            <div class="dropdown-menu" [ngClass]="{'show':subSubitem.isCollapsed}">
                              <ng-template ngFor let-subSubSubitem [ngForOf]="subSubitem.subItems">
                                <a class="dropdown-item side-nav-link-ref" href="javascript: void(0);"
                                  [routerLink]="subSubSubitem.link" routerLinkActive="active" draggable="false">{{
                                  subSubSubitem.label |
                                  translate }}</a>
                              </ng-template>
                            </div>
                          </div>
                          }@else{
                          <a class="dropdown-item side-nav-link-ref" href="javascript: void(0);"
                            [routerLink]="subSubitem.link" routerLinkActive="active" draggable="false">{{
                            subSubitem.label | translate
                            }}</a>
                          }
                        </ng-template>
                      </div>
                    </div>}
                </ng-template>
              </div>
              }
            </li>
          </ng-container>}
        </ul>
      </div>
    </nav>
  </div>
</div>